module.exports = __webpack_public_path__ + "img/tuition-tutorial-03.4a6d1c76.png";